import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

/** No private data, role, sidebar or cached page is rendered while self cannot be verified. */
export default function SessionRecovery({ retry, logout, pending }: {
  retry: () => void
  logout: () => void
  pending: boolean
}) {
  const { t } = useTranslation()
  return <Flex minH="100dvh" align="center" justify="center" p={{ base: 5, md: 8 }} bg="solid.25">
    <Box maxW="480px" w="full" p={{ base: 5, md: 8 }} bg="white" border="1px solid" borderColor="solid.100" borderRadius="20px">
      <Heading as="h1" fontSize="24px">{t('sessionRecovery.title')}</Heading>
      <Text role="status" mt={3} color="solid.600">{t('sessionRecovery.help')}</Text>
      <Flex gap={3} mt={6} wrap="wrap">
        <Button variant="primary" minH="44px" isLoading={pending} onClick={retry}>{t('sessionRecovery.retry')}</Button>
        <Button variant="white" minH="44px" onClick={logout}>{t('sessionRecovery.signOut')}</Button>
      </Flex>
    </Box>
  </Flex>
}
